 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		85: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"ibdPage","4":"legacyIbdPage","7":"ad-AdContainer","8":"components-analytics-analytics","9":"components-feature_feed-feature_feed","10":"container","11":"fc_executive_board","12":"fc_link-fc_link","13":"post-content-body","14":"aboutUsWpPage","15":"author","16":"category_page","17":"customCollectionPage","18":"fc-components-main-components","19":"feed","20":"loginPage","21":"logoutPage","22":"magazineTagPage","23":"magazine_page","24":"myAccountPage","25":"newsletters_page_marketo","26":"notFoundPage","27":"offerPage","28":"playlistIndexPage","29":"playlistPage","30":"podcastPage","31":"post_page","32":"registerPage","33":"resetPasswordPage","34":"sitemapIndex","35":"sitemapPost","36":"stories","37":"subscribePage","38":"tagPage","39":"videoIndex","40":"videoPage","41":"views-containers-layouts-blank_layout-blank_layout","42":"views-containers-layouts-web_layout-web_layout","80":"MarketoNewsletterForm","81":"MicCarousel","82":"MicIcon","83":"MicMobileIconCarousel","84":"Success-SubmissionSuccess","86":"applications-most-innovative-companies","87":"brands_that_matter_2021","88":"brands_that_matter_page","89":"categoryLink","90":"components-BackgroundHighlight-BackgroundHighlight","91":"components-MultiTabList-MultiTabList","92":"components-QuickCarousel-QuickCarousel","93":"components-StickyBar-StickyBar","94":"components-all_feed-all_feed","95":"components-categories","96":"components-config-config","97":"components-editor_highlights-editor_highlights","98":"components-finite_scroll","99":"components-footer-footer","100":"components-franchise_intro-franchise_intro","101":"components-ibd_category-ibd_category","102":"components-image-image","103":"components-magazine_archive-magazine_archive","104":"components-masthead-masthead","105":"components-mcp_section-mcp_section","106":"components-mic_mobile_menu-mic_mobile_menu","107":"components-more-stories-component-more-stories-component","108":"components-newsletters-recaptcha","109":"components-notice","110":"components-piano-pianoBottomBanner","111":"components-podcast_tile-podcast_tile","112":"components-podcast_tile-podcast_tile_featured","113":"components-post-content-insert","114":"components-ranked","115":"components-recirc-recirc","116":"components-related_posts-related_posts","117":"components-related_slider-related_slider","118":"components-sectors_list-sectors_list","119":"components-social-social","120":"components-top_50-top_50","121":"components-top_50_shuffle-top_50_shuffle","122":"components-video_megatron-video_megatron","123":"components-video_module-utils-video_module_ads","124":"components-video_module-video_module","125":"containers-pages-list_landers-bwi-2020","126":"containers-pages-list_landers-ibd-2020","127":"containers-pages-list_landers-mic-2021","128":"content-innovation_festival_banner","129":"content-sponsor_bar","130":"fc-components-main-components-StickyBar-StickyBar","131":"fc-components-main-containers","132":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","133":"fc-components-main-containers-IbdLayout-IbdLayout","134":"fc-components-main-containers-MicLayout-MicLayout","135":"fc-components-main-containers-WciLayout-WciLayout","136":"fc-components-main-utils-ConditionalWrapper","137":"franchises-BtmApplyPage","138":"franchises-BwiApplyPage","139":"franchises-IbdApplyPage","140":"franchises-MicApplyPage","141":"franchises-NbttApplyPage","142":"franchises-WciApplyPage","143":"innovation_by_design_future_page","144":"innovation_by_design_page_franchise","145":"innovation_by_design_page_franchise_2023","146":"layouts","147":"layouts-mcp","148":"nav_main_menu-nav_main_menu","149":"package_article_list_entry","150":"packages-nav-package_sticky_nav","151":"post-content-sidebar","152":"topics"}[chunkId]||chunkId) + "." + {"1":"fe832c12a7182267440b","2":"9aa71f2ea33c3ffe87ae","3":"bef5d26abf61691bc07e","4":"023ba0f144eecc2e0b35","5":"cc840bb5f0c301e6b404","6":"1903350e4f70ba2a9d29","7":"e7c7e03639bec34408b3","8":"c84daeb66bf5bd3fbbc1","9":"335ca0a7fe1f8a9e1b59","10":"76b159e80ebc7edf8e02","11":"935dcbe156517c778416","12":"8699b593de1f4ab0b626","13":"033ecd9a49951751d248","14":"d20fbd3fcb12d5f1f501","15":"aebf7420a4e673b41210","16":"1e5c8c8211c4c4a3dffd","17":"818d10b1647bef20fb1c","18":"0bbb5cf0d870724de86e","19":"5412bba7c520913805ec","20":"a3c9f27c7ed42484dedc","21":"304758751d0e38287053","22":"5c677e19ac3a0747beb6","23":"b77164deb2c90c3fa164","24":"75b9b8f51b97c5d542dd","25":"d66167d7161de0945caa","26":"0dcacbd487970cc7df09","27":"50436006fe8beb2aa134","28":"d0006d0e462898518d10","29":"bba40bfab72b779ba70a","30":"49104d197d0600f9d0d3","31":"52b8008e260e9c55d3d1","32":"f70471c9e3430af05513","33":"53b7710fbde96e948a58","34":"f50b0039b701cb392cee","35":"52fda656d074b6fe958e","36":"c936c0da512dac9271fb","37":"d0d07dea6a6ffbd68065","38":"f7b7555287412e87ee2e","39":"5213dfdf90cfdcea3260","40":"5e18150e24a00c3a703c","41":"0d52c1215d6fe5e751ea","42":"c19f714699dee263c46e","43":"c51341549f2d7468d72e","44":"97d59b42e7e2ff0403b7","45":"df65e84d61f5ee4ca699","46":"b46f7ce6b88b54268563","47":"4fddb88f2f291e3d15f7","48":"903bfc26b6f078df9d9b","49":"643d70bae163266c80e5","50":"c80fef1c0d17ad0e2783","51":"8a8cf776629229d2773b","52":"2ffd823f549be66480fe","53":"d5a06bb50db59ee03e8b","54":"d7fbc7dab4874866d8ab","55":"bfce2ccc40977ac00c93","56":"9b3da6ec1496a9cd70a1","57":"b0637f48fadcfc995657","58":"ba9116fbc87a22807cf2","59":"68e5fe3dc80ab6b0bdb6","60":"2f1b8ad5c19121fda1b5","61":"995d0a7de28dd0372c02","62":"719d508da4212a59dc9e","63":"7b7811867eeaf254ef13","64":"789796b34d16d3335fc5","65":"2978b791415e29f4f48c","66":"81cf2987014b39da026d","67":"582ef229e9d48ba18c81","68":"79bef6149ffb5442599e","69":"835654513809e6eeb1fc","70":"5e6a1f5c4567a8dbbbf0","71":"e264eb3953d5f1455ae3","72":"bd73ce80647d3ccbcd6f","73":"0d8e5045992b6c993c79","74":"974f3f4a9cdf800ab070","75":"4de5896ff43179aca0c5","76":"0b25c07656be41abbc28","77":"a1ee7ca271d8d7fca63c","78":"8b40b1b4639d2cf70083","79":"bbeb2feab778913e011e","80":"ad0b9dbd0145715affcc","81":"842e38a3bfd0f16afa5e","82":"5568bc65432606a4369c","83":"09994f07481339cb3810","84":"4a9dcafaad7f7cbcfc1a","86":"245a9d434baf8adb2ebb","87":"25fc9f433ffed5d49cd6","88":"cd3c2ae5837cb6b442ac","89":"7c1a405f18fc348ef407","90":"aeb1bff4cc3eb83ad3a1","91":"fcfaa95a54bca79aceb7","92":"db5d0f1c940654b61f67","93":"b47bced28528ff14dde4","94":"7d8b1eedc1819e393028","95":"c412e3de486e520d924f","96":"bc1fe18ddccc0c252808","97":"dd64727af3d90a3d7cb1","98":"e72e7d7079429e750eff","99":"195da014ecabd818e195","100":"988f62156603015ffe34","101":"bfaa84a77b9a8afaed30","102":"58ed3c31fb1fd9065a7f","103":"9935f72031e501223bba","104":"6870282bb049b46f49ff","105":"3ace97a9476ea40f82b1","106":"e92cd48b6837a0c5a0e2","107":"45874c434ad58af94303","108":"0094362d4dff72837545","109":"41b00ede38b347af27eb","110":"4e35946538d9013fc60b","111":"f0b3525eaef005fcb5c5","112":"6af07d9d856631ad231d","113":"7d38b57d5790a62b7b0b","114":"459c29580acac08a0879","115":"f20cc852bd06bf77f7d9","116":"a0041f90a3c1a71c0f3e","117":"bc6f2e6e2b53b124e55a","118":"9ed99b4b63e76b8ac168","119":"8877dd33ce13aee51983","120":"7bedc117c9f9410bbeba","121":"808ad3e34afeb5fec6f1","122":"69e3da672312e1fd85d7","123":"4a3c2cc60fabc823617c","124":"10a3d72a417235ca36cb","125":"f152ee8b289acdb92a0a","126":"855bacf5acde706763d7","127":"ff2f74d689da425633f6","128":"ce388b9d67b29a99c018","129":"4b25446c8d0303347d5a","130":"6ef3b23c88b1710f5057","131":"f094819fc4b814ab5203","132":"19ee241d7af5fc611396","133":"eebd3c89a33d94cb5895","134":"33db6073136e556c5293","135":"231c329449a88aeab97e","136":"959da40e37fb189c247f","137":"807186c31e337dc2024e","138":"077c9f721ff7b5bc9db9","139":"e25c6b12561b87557a46","140":"741cf591c06d6bb83fcd","141":"bebb82d518b32d673520","142":"b57e6b44c34e99e1227b","143":"6db896991ac9ab87b516","144":"034324d3871fb44eeb0d","145":"75ba095e8631f809e159","146":"2788208c8baa63495d3a","147":"bc8b58ea6c4b2f2f5194","148":"450bd20b33f7f70f7663","149":"afc8834a007ee8e987e9","150":"ecb816fe549bdd593884","151":"99c648188815c43ae89d","152":"47ad19f884942b2862ac"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([862,153,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
